export default __webpack_public_path__ + "static/media/PROTECH.8b02ddec.webp";